import styled from "styled-components";

import { getOpacityColor, grayScale, red } from "@enkor/design/colors";
import { Typo } from "@enkor/design/components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
`;

export const Title = styled.span`
  margin-bottom: 8px;

  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
`;

export const InputWrapper = styled.label<{ $isError: boolean }>`
  display: flex;
  gap: 16px;
  align-items: center;

  width: 100%;
  height: 40px;
  padding: 11px 8px;
  border: 1px solid ${grayScale.main};
  border-radius: 8px;

  background-color: ${getOpacityColor(grayScale.black, 0.2)};

  & > svg {
    flex-shrink: 0;
  }

  &:has(input:focus) {
    border: 1px solid
      ${({ $isError }) => ($isError ? red.main : grayScale.white)};
  }

  & > button {
    display: flex;
  }
`;

export const Input = styled.input`
  width: 100%;
  height: 100%;
  padding: 0;
  border: none;

  background-color: transparent;

  color: ${grayScale.white};
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;

  &::placeholder {
    color: ${grayScale.main};
  }
`;

export const ErrorMessage = styled(Typo.Text)`
  margin-top: 4px;

  color: ${red.main};
`;

export const GuideWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  margin-top: 16px;
`;

export const GuidePhrase = styled(Typo.Text)``;

export const Characters = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Character = styled.li`
  list-style-type: circle;
`;

export const Indicator = styled(Typo.Text)<{ $isError?: boolean }>`
  color: ${({ $isError }) => ($isError ? red.main : grayScale[700])};
`;
